import type { ISegment } from "@repo/baseCloud";

import { SegmentFilters } from "@repo/baseCloud/components";
import { useSearchParams } from "@repo/helpers";
import { Checkbox, DateTimeRangePicker, filterSpanTwoClassName, FiltersV2, TextBox } from "@repo/ui";
import { endOfDay, startOfDay } from "date-fns";
import { useCallback, useState } from "react";

import type { LeadsFilter } from "../../api/leadsController";

import { LeadsGrid } from "./grid";

export function Leads() {
	const qs = useSearchParams();

	const [filters, setFilters] = useState<LeadsFilter>({
		itemsPerPage: 25,
		currentPage: 1,
		startDate: startOfDay(new Date()),
		endDate: endOfDay(new Date()),
		leadId: qs.has("leadId") ? parseInt(qs.get("leadId")) : undefined,
	});

	const segmentChanged = useCallback((segFilters: ISegment) => setFilters({ ...filters, ...segFilters }), [filters]);

	const filterChanged = (value: LeadsFilter[keyof LeadsFilter], name: string & keyof LeadsFilter) => {
		setFilters({ ...filters, [name]: value });
	};

	return (
		<main className="">
			<FiltersV2>
				<SegmentFilters onChange={segmentChanged} />
				<TextBox
					id="repLogin"
					name="repLogin"
					label={"Rep Login:"}
					value={filters.repLogin ?? ""}
					changeHandler={filterChanged}
					placeholder={"Contains"}
				/>
				<TextBox
					id="customerFirstName"
					name="customerFirstName"
					label={"Customer First Name:"}
					value={filters.customerFirstName ?? ""}
					changeHandler={filterChanged}
					placeholder={"Contains"}
				/>
				<TextBox
					id="customerLastName"
					name="customerLastName"
					label={"Customer Last Name:"}
					value={filters.customerLastName ?? ""}
					changeHandler={filterChanged}
					placeholder={"Contains"}
				/>
				<TextBox
					id="leadId"
					name="leadId"
					label="Lead Id:"
					value={filters.leadId ?? ""}
					changeHandler={filterChanged}
					placeholder={"Matches"}
				/>
				<Checkbox
					id="converted"
					name="converted"
					title="Converted:"
					label=""
					value={filters.converted ?? false}
					changeHandler={filterChanged}
					inline={false}
				/>
				<DateTimeRangePicker
					dateOnly
					id="date-range"
					label="Date Range"
					quickRange
					value={[filters.startDate, filters.endDate]}
					setValue={(v: (Date | undefined)[]) => setFilters({ ...filters, startDate: v[0], endDate: v[1] })}
					className={filterSpanTwoClassName}
				/>
			</FiltersV2>
			<LeadsGrid filters={filters} setFilters={setFilters} />
		</main>
	);
}
